"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SoilMoisture = void 0;
const datamodel_core_1 = require("@iotv/datamodel-core");
const iotv_v3_types_1 = require("@iotv/iotv-v3-types");
const typeName = 'SoilMoisture';
const parser = (val) => {
    return typeof val === 'string' ? parseFloat(val) : val;
};
class SoilMoisture extends datamodel_core_1.DeviceEnabledType {
    // constructor(ob: any, readers?: SoilReadings) {
    constructor(ob, readers) {
        var _a, _b, _c, _d, _e, _f;
        super(ob.type || typeName, ob);
        this.purpose = (_a = ob.purpose) !== null && _a !== void 0 ? _a : '';
        this.sensorModel = (_b = ob.sensorModel) !== null && _b !== void 0 ? _b : null;
        this.depth = (_c = ob.depth) !== null && _c !== void 0 ? _c : 0;
        this.sensorDistance = (_d = ob.sensorDistance) !== null && _d !== void 0 ? _d : 10;
        this.soilTemperature = (_e = ob.soilTemperature) !== null && _e !== void 0 ? _e : null;
        this.image = (_f = ob.image) !== null && _f !== void 0 ? _f : null;
        this.readingCount = ob.readingCount || 1;
        this.updated_at = ob.updated_at ? parser(ob.updated_at) : null;
        if (readers) {
            let longestOption = 1;
            Object.keys(readers).forEach((readerKey) => {
                let keyValues = readers[readerKey];
                this[readerKey] = keyValues;
                if (keyValues && keyValues.length > longestOption) {
                    longestOption = keyValues.length;
                }
            });
            this.readingCount = longestOption;
        }
        delete this.updatedAt;
    }
    getUserAttributes() {
        return {
            ...super.getUserAttributes(),
            name: {
                type: 'String',
                editable: true,
                label: 'Name',
                name: 'name',
                description: 'Name of soil moisture measurement point',
            },
            purpose: {
                type: 'String',
                editable: true,
                label: 'Purpose',
                name: 'purpose',
                description: 'Measurement purpose',
            },
            sensorModel: {
                type: 'String',
                editable: true,
                label: 'Sensor Model',
                name: 'sensorModel',
                description: 'Model of Soil Moisture Sensor and Sensor details',
            },
            depth: {
                type: 'Number',
                editable: true,
                required: true,
                label: 'Sensor Depth (mm)',
                name: 'depth',
                description: 'Depth of the sensor (mm)',
            },
            sensorDistance: {
                type: 'Number',
                editable: true,
                required: true,
                label: 'Distance Between Sensors (mm)',
                name: 'depth',
                description: 'Distance between sensors (mm)',
            },
            moisture: {
                type: 'Number',
                editable: true,
                label: 'Moisture (%)',
                name: 'Moisture',
                description: 'Moisture level (%)',
            },
            soilTemperature: {
                type: 'Number',
                editable: true,
                label: 'Soil Temperature (°C)',
                name: 'soilTemperature',
                description: 'Soil temperature (°C)',
            },
            Location: {
                type: 'RelatedType',
                editable: false,
                label: 'Location',
                name: 'Location',
                description: 'Location of Soil Moisture (lat/ long)',
                objectTypeId: 'Soil_Moisture|P',
                direction: iotv_v3_types_1.PathDirection.child,
                edgeTypeId: 'Soil_Moisture_has_Location_Soil_Moisture|P',
            },
            image: {
                type: 'String',
                editable: true,
                label: 'Image',
                name: 'image',
                description: 'Photograph of Soil Moisture in situ',
            },
        };
    }
}
exports.SoilMoisture = SoilMoisture;
